import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GtinInput from '../GtinInput';
import { FormGroupProps } from './types';
import { ASSIGN_VALUE } from '@/utils/constants';
import { VALIDATION_STATE_WARNING } from '@/utils/validationErrors';
import ReadOnlyField from '../../../common/ReadOnlyField/ReadOnlyField';
import { allowsIdentifierAssignment } from '@/utils/productStateUtils';

type Props = FormGroupProps & {
  handleAlbumField: (field: string, value: string) => void;
  displayValueOnly?: boolean;
};

export default function GtinFormGroup({
  album,
  disabled,
  readonly,
  fieldHasErrors,
  fieldValidationState,
  findErrorMessage,
  handleAlbumField,
  displayValueOnly,
}: Props) {
  const { t } = useTranslation();
  const [gtinInputHasFocus, setGtinInputHasFocus] = useState(false);
  const [gtinChanged, setGtinChanged] = useState(false);
  const showGtinError = fieldHasErrors('GTIN') && !gtinChanged;
  const validationState = fieldValidationState?.('GTIN');
  const errorMessageClassName =
    validationState === VALIDATION_STATE_WARNING
      ? 'col-sm-3 popUp-container-warning'
      : 'col-sm-3 popUp-container';
  const modeSelectorDisabled = !allowsIdentifierAssignment(album.albumState);

  const assignValue =
    album.gtin === ASSIGN_VALUE
      ? t('product.editProduct.assignGtin')
      : album.gtin;

  return (
    <>
      {!readonly ? (
        <FormGroupWithTooltip
          tooltipKey="tooltip.product.upc"
          hasErrors={fieldHasErrors('GTIN')}
        >
          <label htmlFor="gtin" className="col-sm-3 form-label">
            {t('product.editProduct.GTIN')}
          </label>
          <div className="col-sm-6">
            <GtinInput
              value={album.gtin}
              onChange={(value) => {
                setGtinChanged(true);
                handleAlbumField('gtin', value);
              }}
              onInputFocusChange={setGtinInputHasFocus}
              hasError={showGtinError}
              validationState={validationState}
              disabled={disabled}
              modeSelectorDisabled={modeSelectorDisabled}
              hideModeSelector={displayValueOnly}
            />
          </div>
          {showGtinError && gtinInputHasFocus && (
            <div className={errorMessageClassName}>
              {findErrorMessage('GTIN')}
            </div>
          )}
        </FormGroupWithTooltip>
      ) : (
        <ReadOnlyField
          id={'GTIN'}
          labelTitle={t('product.editProduct.GTIN')}
          value={assignValue}
        ></ReadOnlyField>
      )}
    </>
  );
}
